<template>
  <div class="input" :class="{'input--error': errors.first(name), 'input--disabled': disabled }">
    <input
      :type="type"
      class="input__input"
      :id="`${name}-${random}`"
      :name="name"
      v-model="newValue"
      :required="required"
      @input="update"
      :autocomplete="autocomplete"
      placeholder=" "
      :step="step"
      :list="list"
      :disabled="disabled"
    >
    <label :for="`${name}-${random}`" class="input__label">{{ placeholder }}</label>
    <span class="input__line"></span>
    <small class="input__error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'app-input',
  $_veeValidate: {
    value () {
      return this.newValue;
    }
  },
  data() {
    return {
      newValue: this.value,
      random: Math.round(Math.random() * 1000)
    }
  },
  computed: {
    error() {
      return this.errors.items.find(({field}) => field === this.name)?.msg
    }
  },
  props: {
    value: [String, Number],
    type: String,
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: String,
    step: String,
    disabled: Boolean,
    list: String
  },
  methods: {
    update() {
      this.$emit('input', this.newValue)
    }
  },
  watch: {
    value(newVal) {
      this.newValue = newVal
    }
  }
}
</script>

<style lang="scss">
.input {
  width: 100%;
  position: relative;
  margin: 10px 0 8px;

  &__input {
    all: unset;
    display: block;
    box-sizing: border-box;
    border-bottom: solid 1px #ccc;
    color: #333;
    padding: 12px;
    width: 100%;
    text-align: left;
    transition: 0.3s;
    height: 44px;
  }

  &__label {
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 1em;
    color: #ccc;
    font-family: $mainFont;
    transition: 0.3;
    transition: 0.3s;
    cursor: text;
    user-select: none;
  }

  &__line {
    content: '';
    position: absolute;
    bottom: 14px;
    height: 2px;
    background-color: $primaryColor;
    width: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: 0.3s;
    border-radius: 2px;
  }

  &__error {
    display: block;
    height: 14px;
    width: 100%;
    text-align: right;
    font-size: 0.7em;
    color: $errorColor;
    visibility: visible;
    opacity: 1;
    transition: 0.3s;
    transform: translateY(0px);

    &:empty {
      visibility: hidden;
      opacity: 0;
      transform: translateY(4px);
    }
  }

  &--error &__input{
    border-color: $errorColor !important;
  }

  &--error &__error {
    visibility: visible;
    opacity: 1;
  }

  &--disabled &__input {
    color: #aaa;
    cursor: disabled;
  }

  &__input:not(:placeholder-shown) + &__label {
    color: #333;
  }

  &__input:focus + &__label {
    color: $primaryColor;
  }

  &__input:focus + &__label,
  &__input:not(:placeholder-shown) + &__label {
    top: -12px;
    left: 0;
    font-size: 12px;
  }

  &__input:focus ~ &__line{
    width: 100%;
  }

  // &__input:focus {
  //   border-color: $primaryColor;
  // }
}
</style>

